<template>
    <component
        :is="buttonComponent"
        class="button-regular cursor-pointer"
        type="button"
        :class="buttonClasses"
        :disabled="buttonDisabled"
        :to="buttonRoute"
        v-bind="buttonHref ? {href: buttonHref} : {}"
        @click="buttonClick(buttonClickParams)"
    >
        {{ buttonText }}
    </component>
</template>

<script>
export default {
    name: 'ButtonRegular',
    props: {
        buttonColor: {
            required: false,
            type: String,
            default:
                'bg-zinc-100 text-black border border-zinc-200 hover:border-zinc-300 focus-visible:outline-zinc-600',
        },
        buttonDisabled: {
            required: false,
            type: [Boolean, Number],
            default: false,
        },
        buttonRoute: {
            required: false,
            type: [String, Object],
            default: null,
        },
        buttonHref: {
            required: false,
            type: String,
            default: null,
        },
        buttonText: {
            required: false,
            type: String,
            default: null,
        },
        buttonClick: {
            required: false,
            type: Function,
            default: () => {},
        },
        buttonClickParams: {
            required: false,
            type: [String, Object, Array],
            default: null,
        },
    },
    computed: {
        buttonComponent() {
            if (this.buttonRoute) return 'router-link';
            if (this.buttonHref) return 'a';
            return 'button';
        },
        buttonClasses() {
            const cls = {};
            cls['inline-block'] = true;
            cls['px-3 py-2'] = true;
            cls['rounded-md shadow-xs'] = true;
            cls['cursor-pointer'] = true;
            cls['focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2'] = true;
            cls['sm:text-lg font-medium'] = true;
            cls[this.buttonColor] = true;
            cls['disabled:bg-zinc-500'] = !!this.buttonDisabled;
            return cls;
        },
    },
};
</script>
